import React, { useEffect, useState } from 'react'
import Loader from '../../../components/elements/Loader'
import UserLayout from '../../../components/layouts/UserLayout';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { authHeader } from '../../../utils';
import { ERROR, SET_SUCCESS, UPDATING_STUDENT } from '../../../store/types';
import axios from 'axios';

import UpdateStudentMedicals from '../../../components/partials/students/UpdateStudentMedicals';

const UpdateMedicals = () => {
    const [admissionOffer, setAdmissionOffer] = useState(null);
    const [loading, setLoading] = useState(true);
    const { admissionOfferId } = useParams()
    const dispatch = useDispatch()

    const navigate = useNavigate()

    useEffect(() => {
        const fetchAdmissionOffer = async () => {
            try {
                const headers = authHeader()

                const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/admission-offers/${admissionOfferId}?expand=acceptanceFee,application`, { headers })            

                setAdmissionOffer(response.data.data)
                setLoading(false)

            } catch (error) {
                console.log(error)
                dispatch({
                    type: ERROR,
                    error
                })
                setLoading(false)
            }
        }

        fetchAdmissionOffer()

        return () => {
        
        };
    }, [admissionOfferId, dispatch]);

    const submitMedicals = async (payload) => {
        try {
            const headers = authHeader()
            dispatch({
                type: UPDATING_STUDENT,
                payload:true
            })
            await axios.post(`${process.env.REACT_APP_BASE_URL}/admission-offers/confirm-acceptance/${admissionOfferId}`, payload, { headers }) 
            
            dispatch({
                type: SET_SUCCESS,
                payload: 'Medical information saved successfully!'
            })
            
            navigate(`/user/students/student/${admissionOffer.student}`)

        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
            dispatch({
                type: UPDATING_STUDENT,
                payload:false
            })
        }
    }

    return (
        <UserLayout>
            {loading ? 
                <Loader />
            :
                <div className='mt-5 w-full xl:w-1/2 mx-auto'>
                    <div className='w-full p-[16px relative'>
                        <h3 className='font-[500] text-[15px] text-vcm-purple'> 
                            Student Medicals
                        </h3>
                        <p className='text-gray-600 text-sm'>
                            Please provide the following medical information for your ward to complete the enrolment process.
                        </p>
                    </div>

                    <UpdateStudentMedicals submitMedicals={(payload)=>{submitMedicals(payload)}} />
                </div>
            }

        </UserLayout>
    )
}

export default UpdateMedicals